<!-- 白名单 -->
<template>
<div class="whiteList bgc box-shadow">
    <el-button type="primary" @click="handleAddWhiteList">新建名单</el-button>
    <el-table :data="tableData">
        <el-table-column label="序号" width="80px" align="center">
            <template slot-scope="scope">
                {{(page - 1) * pagesize + scope.$index + 1}}
            </template>
        </el-table-column>
        <el-table-column label="用户ID" align="center" prop="customerinnerid"></el-table-column>
        <el-table-column label="用户名称" align="center" prop="customername"></el-table-column>
        <el-table-column label="有效功能" align="center" prop="kmctypename"></el-table-column>
        <el-table-column label="有效时间" align="center" prop="expiretime"></el-table-column>
        <el-table-column label="创建时间" align="center" prop="datetime"></el-table-column>
        <el-table-column label="操作" align="right">
            <template slot-scope="scope">
                <div class="actionBtn">
                    <span @click="handleEdit(scope.row.innerid)">编辑</span>
                    <span> | </span>
                    <span @click="handlesDelete(scope.row.innerid)">删除</span>
                </div>
            </template>
        </el-table-column>
    </el-table>
    <Page ref='page' :total="total" @getList="findAllCustomer" />
    <MaintainWhiteList ref="maintainWhiteList" @editWhiteListItemSuccess="handleEditWhiteListItemSuccess" @addWhiteListItemSuccess="handleAddWhiteListItemSuccess" />
</div>
</template>

<script>
import {findAllCustomer, deleteWhiteCustomInfo} from '@/api/accountApi.js'
import Page from '@/base/page/page.vue'
import MaintainWhiteList from './whiteList/maintainWhiteList.vue'
import {mapActions} from 'vuex'
export default {
    data() {
        return {
            params: {
                name: ''
            },
            tableData: [],
            total: 0,
            page: 1,
            pagesize: 10
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {
        
        this.findAllCustomer()
    },
    methods: {
        findAllCustomer() {
            this.setLoading(true)
            this.page = this.$refs.page.page.page
            findAllCustomer({
                data: Object.assign({}, this.params, this.$refs.page.page),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 新增
        handleAddWhiteList() {
            this.$refs.maintainWhiteList.handleOpen()
        },
        // 新增成功
        handleAddWhiteListItemSuccess() {
            this.$refs.page.pagination.page = 1
            this.page = 1
            this.findAllCustomer()
        },
        // 编辑
        handleEdit(innerid) {
            this.$refs.maintainWhiteList.handleOpen(innerid)
        },
        // 编辑成功
        handleEditWhiteListItemSuccess() {
            this.findAllCustomer()
        },
        // 删除
        handlesDelete(innerid) {
            this.$confirm('名单删除只影响后续的内容，确定需要删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                this.setLoading(true)
                deleteWhiteCustomInfo({
                    data: {innerid},
                    success: data => {
                        this.setLoading(false)
                        this.$message.success(data.msg)
                        if (this.tableData.length === 1) {
                            if (this.$refs.page.page.page > 1) {
                                this.setPage({page: this.$refs.page.page.page - 1, pageSize: 10})
                            }
                        }
                        this.findAllCustomer()
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
        ...mapActions([
            'setLoading',
            'setPage'
        ])
    },
    components: {
        Page,
        MaintainWhiteList
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.whiteList {
    padding: 20px;
    box-sizing: border-box;
    .el-button {
        width: 110px;
        height: 36px;
        margin-bottom: 20px;
    }
    .el-table {
        .actionBtn {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            span {
                cursor: pointer;
                font-size: 12px;
                margin-left: 10px;
                color: #409EFF;
            }
        }
    }
}
</style>